import { useSupportSheet } from "../../components/SupportSheet";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { BodyCopy } from "../../components/BodyCopy";
import {
  AuraLayout,
  Button,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { FlowHeroMark } from "../../components/FlowHeroMark";
import { DiscardCardIcon, SupportStrokeIcon } from "../../assets/icons";
import { useStore } from "../../store/globalState";
import { PAYOUT_CLAIM_ROUTES } from "../../constants";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";
import { Navbar } from "../../components/Navbar";

const SENDER_NAME = "Carlos Mendoza";

/**
 * Gallery-safe discard interstitial (payout-claim). Regresar → intention.
 */
export const IntentionDiscardPage = memo(() => {
  const { t } = useTranslation("payout-claim");
  const { theme } = useStore();
  const navigate = useNavigate();
  const { openSupport, supportSheet } = useSupportSheet("payout-claim");

  const colorConfig = theme.errorView;
  const {
    backgroundBtn,
    textColorBtn,
    title,
    bodyCopy,
    iconColors,
    backgroundIcon,
  } = colorConfig;

  return (
    <>
    <AuraLayout colorConfig={colorConfig} className="need-help-header flow-landing-page">
      <Layout.Header>
        <Navbar
          title={t("common.needHelp")}
          align="right"
          noBackButton
          color={title}
          onIconClick={openSupport}
          icon={
            <SupportStrokeIcon
              size={35}
              colors={[backgroundIcon, backgroundIcon]}
              glyphColor={iconColors[0]}
            />
          }
        />
      </Layout.Header>
      <Layout.Content className="landing-section flow-hero-section flow-hero-section--with-header">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark backgroundIcon={backgroundIcon}>
            <DiscardCardIcon size={60} colors={iconColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("payoutClaim.discardScreen.highlight")}
              highlightColor={title}
              secudnary={t("payoutClaim.discardScreen.secondary")}
              secudnaryColor={title}
            />
            <BodyCopy textColor={bodyCopy}>
              {t("payoutClaim.discardScreen.body", { name: SENDER_NAME })}
            </BodyCopy>
          </section>
        </section>
      </Layout.Content>
      <Layout.Footer>
        <section className="footer-section">
          <Button
            size="large"
            background={backgroundBtn}
            color={textColorBtn}
            onClick={() => navigate(PAYOUT_CLAIM_ROUTES.CLAIM_ENTRY)}
          >
            {t("payoutClaim.discardScreen.cta")}
          </Button>
        </section>
      </Layout.Footer>
    </AuraLayout>
      {supportSheet}
    </>
  );
});
